import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  header2: {
    fontSize: 18,
    color: colour.grey[200],
    margin: "0 0 10px 0"
  },
  microcopy: {
    fontSize: 16,
    color: colour.grey[300],
    margin: "0 0 20px 0"
  },
  error: {
    color: "#D80000",
    fontSize: 16,
    paddingBottom: 20,
    display: "block"
  },
  label: {
    fontSize: 18,
    color: colour.grey[200],
    marginLeft: 10
  },
  checkbox: {
    border: `2px solid ${colour.grey[500]}`,
    height: 44,
    width: 44,
    padding: 8,
    borderRadius: 3,
    ":hover": {
      backgroundColor: colour.grey[500]
    }
  },
  checkboxWrapper: {
    display: "inline-flex",
    alignItems: "center",
    marginRight: 50,
    marginBottom: 10
  },
  checkboxChecked: {
    background: colour.brand.blue,
    borderColor: colour.brand.blue,
    ":hover": {
      background: colour.brand.blue,
      borderColor: colour.brand.blue
    }
  },
  radio: {
    border: `2px solid ${colour.grey[500]}`,
    height: 44,
    width: 44,
    padding: 10,
    borderRadius: 200,
    ":hover": {
      backgroundColor: colour.grey[500]
    }
  },
  radioIcon: {
    background: "#fff",
    display: "block",
    width: 20,
    height: 20,
    borderRadius: 200
  },
  radioIconChecked: {
    background: colour.brand.blue
  },
  hidden: {
    height: 0,
    width: 0,
    position: "absolute",
    left: 9999
  },
  checkboxIcon: {
    height: 24,
    width: 24
  }
});
